import { useQuery } from '@tanstack/react-query'
import { getBlogBySlug } from '../api/blogs'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import { mapBlogPostDetail, type BlogPostDetail } from '../helpers/mapContent'

type BlogPostState = {
  post: BlogPostDetail | null
  loading: boolean
  error: string | null
}

export function useBlogPost(slug: string | undefined): BlogPostState {
  const blogQuery = useQuery({
    queryKey: QUERY_KEYS.blog(slug ?? ''),
    queryFn: () => getBlogBySlug(slug!),
    enabled: Boolean(slug),
  })
  const error = !slug
    ? 'Blog post not found'
    : blogQuery.error
      ? toApiMessage(blogQuery.error, 'Failed to load blog post')
      : null

  return {
    post: blogQuery.data ? mapBlogPostDetail(blogQuery.data) : null,
    loading: Boolean(slug) && blogQuery.isPending && !blogQuery.data && !error,
    error,
  }
}
